/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo InstanciaTenants.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/instancia-tenants',
    name: 'instancia_tenants.index',
    component: () => import('./views/InstanciaTenantsIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'instancia_tenants.read',
      title: 'Instancia_tenants',
    },
  },
]

export default routes
